import axios from "axios";
import { API_URL } from "../utils/api-config";

export interface HandlingEquipment {
  _id: string;
  equipmentType: string;
  internalNumber: string;
  serialNumber?: string;
  brand: string;
  model: string;
  loadCapacity?: number;
  state?: string; // Ancien format
  operationalState?: string; // Nouveau format
  location?: string;
  ownershipStatus?: string;
  purchaseDate?: string;
  purchasePrice?: number;
  comments?: string;
  // Suivi des affectations
  currentAssignmentId?: string;
  currentDriverId?: string;
  currentDriverName?: string;
  lastDriverId?: string;
  lastDriverName?: string;
  lastAssignmentDate?: string;
  totalAssignments?: number;
  createdAt?: string;
  updatedAt?: string;
}

const HandlingEquipmentService = {
  getAll: async (): Promise<HandlingEquipment[]> => {
    const response = await axios.get(`${API_URL}/handling-equipment`);
    return response.data;
  },

  getById: async (id: string): Promise<HandlingEquipment> => {
    const response = await axios.get(`${API_URL}/handling-equipment/${id}`);
    return response.data;
  },

  create: async (data: Partial<HandlingEquipment>): Promise<HandlingEquipment> => {
    const response = await axios.post(`${API_URL}/handling-equipment`, data);
    return response.data;
  },

  update: async (id: string, data: Partial<HandlingEquipment>): Promise<HandlingEquipment> => {
    const response = await axios.put(`${API_URL}/handling-equipment/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await axios.delete(`${API_URL}/handling-equipment/${id}`);
  },

  archive: async (id: string): Promise<HandlingEquipment> => {
    const response = await axios.put(`${API_URL}/handling-equipment/${id}/archive`);
    return response.data;
  },

  unarchive: async (id: string): Promise<HandlingEquipment> => {
    const response = await axios.put(`${API_URL}/handling-equipment/${id}/unarchive`);
    return response.data;
  },
};

export default HandlingEquipmentService;

